import { Box, styled } from '@mui/joy';

import { HEADER_HEIGHT, LEFT_MENU_WIDTH } from 'theme/constants';

interface IWrapperProps {
  hasGlobalSearch?: boolean;
}

const propsToSkip: PropertyKey[] = ['hasGlobalSearch'];
const shouldForwardProp = (propName: PropertyKey) => !propsToSkip.includes(propName);

export const Wrapper = styled(Box, { shouldForwardProp })<IWrapperProps>(
  ({ theme, hasGlobalSearch }) => ({
    position: 'fixed',
    width: `calc(100vw - ${LEFT_MENU_WIDTH}px)`,
    zIndex: 2,
    top: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: hasGlobalSearch ? 'space-between' : 'flex-end',
    padding: '16px 24px',
    height: HEADER_HEIGHT,
    borderBottom: `1px solid ${theme.palette.neutral.outlinedBorder}`,
  })
);

export const RightSideWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '24px',
});
